// extracted by mini-css-extract-plugin
export var backdropBlur = "_70-0";
export var body = "_70-5";
export var bodyScroll = "_70-6";
export var columnFooter = "_70-7";
export var columnFooterFlush = "_70-8";
export var contentColumn = "_70-4";
export var frame = "_70-3";
export var heroContent = "_70-c";
export var heroOverlay = "_70-b";
export var image = "_70-a";
export var imageWrapper = "_70-9";
export var modal = "_70-1";
export var modalMain = "_70-2";
export var productHeader = "_70-d";
export var productHeaderIcon = "_70-e";
export var productHeaderName = "_70-f";
export var progressIndicator = "_70-g";